import React, { Component } from 'react'
import { Link } from "react-router-dom";
import Header from './header';
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import { withRouter } from 'react-router';

class Search extends Component {

    showResults(s) {
        this.props.history.push({
          pathname: '/Search',
          state: { searchResults: s }
        })
      }

    render() {
        return (
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <Header  showResults={this.showResults.bind(this)}  />
                    <div className="container-fluid">
                        <div>
                            <div className="h3 mb-2 text-gray-800">
                                {this.props.location.state.searchResults.length} <span> matching result(s)</span>
                            </div>
                            <div>
                                {
                                    this.props.location.state.searchResults.map((r) => {
                                        return (
                                            <Link key={r.page.Path} to={{ pathname: r.page.Route }} className="nav-link"> <span><Translate id={r.page.Menu} /></span></Link>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="sticky-footer bg-white">
                    <div className="container my-auto">
                        <div className="copyright text-center my-auto">
                            <span>Copyright © PeriaIT 2019</span>
                        </div>
                    </div>
                </footer>
            </div>

        );
    }
}

export default withRouter(withLocalize(Search))